import { createAsyncThunk } from "@reduxjs/toolkit";

import publisherAPI from "../../services/api/publisher";

export const createSocialProfile = createAsyncThunk("socialProfile/createSocialProfile", async (payload) => {
  try {
    const response = await publisherAPI.createSocialProfile(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error || error;
  }
});

export const updateSocialProfile = createAsyncThunk("socialProfile/updateSocialProfile", async (payload) => {
  try {
    const response = await publisherAPI.updateSocialProfile(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error || error;
  }
});

export const deleteSocialProfile = createAsyncThunk("socialProfile/deleteSocialProfile", async (payload) => {
  try {
    const response = await publisherAPI.deleteSocialProfile(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error || error;
  }
});

export const getSocialProfiles = createAsyncThunk("socialProfile/getSocialProfiles", async (payload) => {
  try {
    const response = await publisherAPI.getSocialProfiles(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error || error;
  }
});

export const getCustomProfileAuthUrl = createAsyncThunk("socialProfile/getCustomProfileAuthUrl", async (payload) => {
  try {
    const response = await publisherAPI.getCustomProfileAuthUrl(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error || error;
  }
});

export const completeSocialMediaAuth = createAsyncThunk("socialProfile/completeSocialMediaAuth", async (payload) => {
  try {
    const response = await publisherAPI.completeSocialMediaAuth(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error || error;
  }
});

export const getSocialMediaProviderProfiles = createAsyncThunk(
  "socialProfile/getSocialMediaProviderProfiles",
  async (payload) => {
    try {
      const response = await publisherAPI.getSocialMediaProviderProfiles(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error?.response?.data?.error || error;
    }
  },
);

export const disconnectCustomSocialMediaPlatform = createAsyncThunk(
  "socialProfile/disconnectCustomSocialMediaPlatform",
  async (payload) => {
    try {
      const response = await publisherAPI.disconnectCustomSocialMediaPlatform(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error?.response?.data?.error || error;
    }
  },
);

export const generateProfileJwt = createAsyncThunk("socialProfile/generateProfileJwt", async (payload) => {
  try {
    const response = await publisherAPI.generateProfileJwt(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error || error;
  }
});
